/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTasksNamesQuery } from '../../models/get-project-tasks-names-query';
import { GetProjectTasksNamesQueryResult } from '../../models/get-project-tasks-names-query-result';

export interface ApiProjectTaskGetProjectTasksNamesPost$Params {
      body?: GetProjectTasksNamesQuery
}

export function apiProjectTaskGetProjectTasksNamesPost(http: HttpClient, rootUrl: string, params?: ApiProjectTaskGetProjectTasksNamesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTasksNamesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskGetProjectTasksNamesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTasksNamesQueryResult>;
    })
  );
}

apiProjectTaskGetProjectTasksNamesPost.PATH = '/api/ProjectTask/GetProjectTasksNames';
